import { Injectable } from '@angular/core';

import { AbstractAsyncTaskReport } from './abstract-async-task.report';
import { ITask } from './async-task-constants';

interface IRowError {
  row: number;
  error: string;
}

interface IFileContentError {
  error_type: string;
  attachment_id?: number;
  error_detail?: IRowError[];
}

@Injectable({
  providedIn: 'root'
})
export class MondayQuoteCatalogImportReport extends AbstractAsyncTaskReport {

  public generate(task: ITask): string {
    if (task.status === 'success') {
      return `<div>Import du catalogue Monday réussi.</div>`;
    }

    let htmlDetail = `<div>Échec de l'import du catalogue Monday.<br></div>`;
    htmlDetail += this.formatOnlyStructureAndContentImportError(task.detail, {
      INVALID_FILE_CONTENT: (error: IFileContentError): string => this._handleFileContentError(error),
      MONDAY_QUOTE_CATALOG_IMPORT_ERROR: (error: { error: string }): string =>
        `Une erreur inattendue s'est produite lors de l'import : ${error.error || ''}`,
    });
    return htmlDetail;
  }

  private _handleFileContentError(error: IFileContentError): string {
    // If there are row-level errors (post-validation import errors)
    if (error.error_detail && Array.isArray(error.error_detail) && error.error_detail.length > 0) {
      let errorString = `Certaines lignes n'ont pas pu être importées :`;
      errorString += `<ul>`;
      errorString += error.error_detail.map((rowError: IRowError) =>
        `<li>Ligne ${rowError.row} : ${rowError.error}</li>`
      ).join('');
      errorString += `</ul>`;
      return errorString;
    }

    // If there is a validation report to download
    if (error.attachment_id) {
      return `Certaines lignes n'ont pas passé l'étape de validation.
        <br><br>
        <a href="${this.apiShiva.attachments.downloadUrl(error.attachment_id)}" class="btn btn-default" target="_blank">
          <i class="far fa-file-excel" aria-hidden="true"></i>
          Télécharger le rapport
        </a>`;
    }

    return `Certaines lignes n'ont pas passé l'étape de validation.`;
  }
}

